<template>
    <div class="threeJS">
        <el-button-group style="float:left;margin:10px;">
        <el-button size="small" v-for="item in menuList" :key="item.name" :class="{active : active == item.name}" @click="selected(item.name)">{{item.name}}</el-button>
        </el-button-group>
        <div id="container" class="container">
        </div>
        <div id="label"></div>
    </div>
</template>

<script>
import * as Three from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js'
// import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { OBJLoader, MTLLoader } from 'three-obj-mtl-loader'
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { OBJLoader } from 'three-obj-mtl-loader'

// const raycaster = new Three.Raycaster()// 创建光线投射对象
var mouse = new Three.Vector2()// 创建二维平面
var sensor = []
var selectObj
var lastSelectObj
export default {
  data () {
    return {
      active: '',
      menuList: [
        {name: 'Cam1'},
        {name: 'Cam2'},
        {name: 'Cam3'},
        {name: 'Cam4'},
        {name: 'Restore'}
      ],
      camera: null,
      scene: null,
      renderer: null,
      // mesh: null,
      lastSelectObjMaterial: null,
      cameraTarget: null,
      camerePosition: {x: 0, y: 0, z: 120},
      sensorName: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  /* beforeDestroy () {
    this.renderer.forceContextLoss()
    this.renderer = null
  }, */
  methods: {
    init () {
      this.createScene() // 创建场景
      this.loadSTL() // 加载STL模型
      this.createLight() // 创建光源
      this.createCamera() // 创建相机
      this.createRender() // 创建渲染器
      this.createControls() // 创建控件对象
      this.render() // 渲染
      window.addEventListener('resize', this.onWindowResize, false)
      // this.scene.fog = new Three.Fog(0x72645b, 2, 15)
    },
    createScene () {
      // 创建场景
      this.scene = new Three.Scene()
      // 添加坐标轴
      // let axes = new Three.AxesHelper(20)
      // this.scene.add(axes)
      // Ground
      /* let planeGeometry = new Three.PlaneGeometry(60, 20)
      let planeMaterial = new Three.MeshLambertMaterial({color: 0xcccccc})
      let plane = new Three.Mesh(planeGeometry, planeMaterial)
      plane.receiveShadow = true
      plane.rotation.x = -Math.PI / 2
      // plane.position.y = 0.5
      this.scene.add(plane) */
    },
    loadSTL () {
      // 加载文件
      /* new STLLoader().setPath('/static/').load('立方体.STL', geometry => {
        // 创建纹理
        var material = new Three.MeshLambertMaterial({ color: 'red' }) // { color: 0x00ffff }
        // console.log(material)
        geometry.name = '立方体'
        // 缩放几何体
        geometry.scale(0.01, 0.01, 0.01)
        // 几何体居中
        geometry.center()
        // 平移立方体
        // geometry.translate(-50, -50, -50)
        console.log(geometry)
        var mesh = new Three.Mesh(geometry, material)
        // mesh.rotation.x = -0.5 * Math.PI // 将模型摆正
        mesh.scale.set(0.01, 0.01, 0.01) // 缩放
        mesh.castShadow = true
        mesh.receiveShadow = true
        console.log(mesh)
        this.scene.add(mesh)
      })
      console.log(this.scene) */
      new MTLLoader().setPath('./static/model/').load('BridgeAssembly-0509.mtl', materials => {
        // console.log('materials', materials)
        materials.preload()
        new OBJLoader().setMaterials(materials).setPath('./static/model/').load('BridgeAssembly-0509.obj', obj => {
          obj.scale.set(0.006, 0.006, 0.006)
          obj.position.set(-30, -95, 60)
          // obj.rotation.x = 0.5 * Math.PI // 将模型背面作为正面
          this.scene.add(obj)
          sensor.push(obj)
        })
      })
      /* var objLoader = new OBJLoader()
      objLoader.load('/static/b.obj', obj => {
        var material = new Three.MeshLambertMaterial({color: 'red'})
        // geometry is a group of children. If a child has one additional child it's probably a mesh
        obj.children.forEach(function (child) {
          if (child.children.length === 1) {
            if (child.children[0] instanceof Three.Mesh) {
              child.children[0].material = material
            }
          }
        })
        obj.scale.set(0.004, 0.004, 0.004)
        obj.position.set(-40, -40, -65)
        this.scene.add(obj)
      }) */
      /* var loader = new FBXLoader()// 创建一个FBX加载器
      loader.load('SambaDancing.fbx', function (obj) {
      // console.log(obj)
        this.scene.add(obj)
        obj.translateY(-80)
        // obj作为参数创建一个混合器，解析播放obj及其子对象包含的动画数据
        var mixer = new Three.AnimationMixer(obj)
        // 查看动画数据
        console.log(obj.animations)
        // obj.animations[0]：获得剪辑对象clip
        var AnimationAction = mixer.clipAction(obj.animations[0])
        // AnimationAction.timeScale = 1; //默认1，可以调节播放速度
        // AnimationAction.loop = THREE.LoopOnce; //不循环播放
        // AnimationAction.clampWhenFinished=true;//暂停在最后一帧播放的状态
        AnimationAction.play()// 播放动画
      }) */
      /* new GLTFLoader().load('/static/BridgeAssembly_zk.glb', function (gltf) {
        gltf.scene.name = '3dmodel'
        this.setContent(gltf.scene)
        this.scene.add(gltf.scene)
      }, undefined, function (e) {
        console.error(e)
      }) */
    },
    createLight () {
      // 环境光
      const ambientLight = new Three.AmbientLight(0xffffff, 0.1) // 创建环境光
      this.scene.add(ambientLight) // 将环境光添加到场景

      const spotLight = new Three.SpotLight(0xffffff) // 创建聚光灯
      spotLight.position.set(200, 0, 180)
      spotLight.castShadow = true
      this.scene.add(spotLight)
    },
    createCamera () {
      // 创建相机
      let container = document.getElementById('container')
      const width = container.clientWidth // 窗口宽度
      const height = container.clientHeight // 窗口高度
      const k = width / height // 窗口宽高比
      this.camera = new Three.PerspectiveCamera(50, k, 0.01, 1000)
      // 设置视角离原点的位置（眼睛距离模型的距离）
      // this.camera.position.z = 6
      // 设置相机位置
      this.camera.position.set(this.camerePosition.x, this.camerePosition.y, this.camerePosition.z)
      this.cameraTarget = new Three.Vector3(0, 0, 0)
      // this.camera.lookAt(this.cameraTarget) // 设置相机方向
    },
    createRender () {
      let container = document.getElementById('container')
      // 创建渲染器
      this.renderer = new Three.WebGLRenderer({antialias: true, alpha: true}) // 锯齿消除
      // this.renderer = new Three.WebGLRenderer()
      this.renderer.shadowMap.enabled = true // 显示阴影
      this.renderer.shadowMap.type = Three.PCFSoftShadowMap
      this.renderer.setClearColor(0xEEEEEE) // 设置背景颜色
      this.renderer.setPixelRatio(window.devicePixelRatio)// 分辨率
      // 设置渲染区域尺寸
      this.renderer.setSize(container.clientWidth, container.clientHeight)
      container.appendChild(this.renderer.domElement)
      console.log(this.scene)
      container.addEventListener('click', this.onMouseClick, false)
    },
    // 创建控件对象
    createControls () {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.controls.target = new Three.Vector3(0, 0, 0) // 控制目标的坐标（旋转时以此坐标为中心点）
      this.controls.minPolarAngle = 0
      this.controls.maxPolarAngle = Math.PI
    },
    render () {
      requestAnimationFrame(this.render)
      // this.renderRaycasterObj()
      this.renderer.render(this.scene, this.camera)
    },
    onWindowResize () {
      let container = document.getElementById('container')
      this.camera.aspect = container.clientWidth / container.clientHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(container.clientWidth, container.clientHeight)
    },
    restoreModel () {
      this.camera.position.set(this.camerePosition.x, this.camerePosition.y, this.camerePosition.z)
      this.camera.lookAt(this.cameraTarget)
      this.renderer.render(this.scene, this.camera)
    },
    onMouseClick (e) {
      let mainCanvas = document.getElementById('container')
      let X = e.offsetX / mainCanvas.clientWidth
      let Y = e.offsetY / mainCanvas.clientHeight
      mouse.x = X * 2 - 1
      mouse.y = -Y * 2 + 1
      this.renderRaycasterObj()

      if (selectObj !== undefined && selectObj !== null) {
        this.renderDiv(selectObj)
        // console.log(this.sensorName)
        this.handelJump(this.sensorName)
      }
    },
    renderRaycasterObj () {
      // 创建射线投射器对象
      let rayCaster = new Three.Raycaster()
      // raycaster的作用场景
      rayCaster.setFromCamera(mouse, this.camera)
      let Arr = this.scene.children
      if (Arr !== 0 && Arr[2] instanceof Three.Group) {
        // 返回射线选中的对象 第二个参数如果不填 默认是false
        let intersectsObjArr = rayCaster.intersectObjects(Arr[2].children, true)
        // console.log(intersectsObjArr)
        if (intersectsObjArr.length !== 0 && intersectsObjArr[0].object instanceof Three.Mesh) {
          if (this.contains('Bridge Assembly-0509/Strain_gauge', intersectsObjArr[0].object.name)) {
            selectObj = intersectsObjArr[0].object
            // 保留原来的材质
            this.lastSelectObjMaterial = selectObj.material
            this.sensorName = selectObj.name.substr(selectObj.name.lastIndexOf('/') + 1)
            // console.log(this.lastSelectObjMaterial)
          }
        }
      }
    },
    handelJump (name) {
      this.$emit('handelJump', name)
    },
    changeSelectObjMaterial () {
      if (lastSelectObj !== undefined && lastSelectObj !== null) {
        lastSelectObj.material = this.lastSelectObjMaterial
      }
      selectObj.material = new Three.MeshPhongMaterial({color: 'orange'})// 移到物体上时颜色变成橘色
      // selectObj.scale = new Three.Vector3(1.2, 1.2, 1.2)
      lastSelectObj = selectObj
    },
    renderDiv (object) {
      this.changeSelectObjMaterial()
      /** 不固定显示 */
      // let container = document.getElementById('container')
      // 获取窗口的一半高度和宽度
      /* var halfWidth = container.clientWidth / 2
      var halfHeight = container.clientHeight / 2

      // 逆转相机求出二维坐标
      var vector = object.position.clone().project(this.camera)

      // 修改 div 的位置
      $('#label').css({
        left: vector.x * halfWidth + halfWidth,
        top: -vector.y * halfHeight + halfHeight - object.position.y
      }) */

      /** 固定显示 */
      /* var width = container.clientWidth
      var height = container.clientHeight
      $('#label').css({
        left: width,
        top: height
      }) */
      // 显示模型信息
      $('#label').text('name: ' + object.name.substr(object.name.lastIndexOf('/') + 1))
    },
    selected (name) {
      this.active = name
      if (name === 'Restore') {
        this.restoreModel()
      } else {
        this.changeCameraView(name)
      }
    },
    changeCameraView (name) {
      var x, y, z
      if (name === 'Cam1') {
        x = 120
        y = 0
        z = -60
      } else if (name === 'Cam2') {
        x = 0
        y = 0
        z = -120
      } else if (name === 'Cam3') {
        x = 0
        y = 120
        z = 0
      } else if (name === 'Cam4') {
        x = -120
        y = 0
        z = 60
      }
      this.camera.position.set(x, y, z)
      this.camera.lookAt(this.cameraTarget)
      this.renderer.render(this.scene, this.camera)
    },
    contains (subs, str) {
      return str.indexOf(subs) >= 0
    }
  }
}
</script>
<style scoped>
.threeJS {
    /* background-color: #fff;*/
    text-align: center;
    height: 450px;
    margin-bottom: 32px;
  }
.container {
    background-color: #EEEEEE;
    text-align: center;
    height: 400px;
    width: 100%;
    margin-bottom: 32px;
  }
.active {
   background: #fd7522;
   border: 1px solid #fd7522;
   color: #fff;
 }
#label {
            position: absolute;
            /*background: rgba(255, 255, 255, 0.6);*/
            line-height: 1;
            border-radius: 5px;
        }
</style>



// WEBPACK FOOTER //
// src/components/ThreeJSView/index.vue